export const CAPTURE_PREFERENCES_STORAGE_KEY = "vocabularium_capture_preferences";

export const CAPTURE_AFTER_BEHAVIORS = {
  REGISTER: "register",
  STAY: "stay",
};

export const DEFAULT_CAPTURE_PREFERENCES = {
  afterCaptureBehavior: CAPTURE_AFTER_BEHAVIORS.REGISTER,
};

export const CAPTURE_AFTER_BEHAVIOR_LABELS = {
  [CAPTURE_AFTER_BEHAVIORS.REGISTER]: "Être redirigé vers le registre",
  [CAPTURE_AFTER_BEHAVIORS.STAY]: "Rester sur la capture de mot",
};

const VALID_AFTER_BEHAVIORS = new Set(Object.values(CAPTURE_AFTER_BEHAVIORS));

export function sanitizeCapturePreferences(raw) {
  if (!raw || typeof raw !== "object") {
    return { ...DEFAULT_CAPTURE_PREFERENCES };
  }

  return {
    afterCaptureBehavior: VALID_AFTER_BEHAVIORS.has(raw.afterCaptureBehavior)
      ? raw.afterCaptureBehavior
      : DEFAULT_CAPTURE_PREFERENCES.afterCaptureBehavior,
  };
}

export function readCapturePreferences() {
  try {
    const stored = localStorage.getItem(CAPTURE_PREFERENCES_STORAGE_KEY);
    if (!stored) return { ...DEFAULT_CAPTURE_PREFERENCES };
    return sanitizeCapturePreferences(JSON.parse(stored));
  } catch {
    return { ...DEFAULT_CAPTURE_PREFERENCES };
  }
}

export function writeCapturePreferences(preferences) {
  try {
    localStorage.setItem(
      CAPTURE_PREFERENCES_STORAGE_KEY,
      JSON.stringify(sanitizeCapturePreferences(preferences))
    );
  } catch {
    // ignore quota errors
  }
}
